import script from "./DateRangeSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./DateRangeSelect.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__